import { useAuth } from '../contexts/AuthContext';
import { dpsTheme } from '../styles/dpsTheme';
import { ClientDashboard } from '../components/dashboard/ClientDashboard';
import { AdvisorDashboard } from '../components/dashboard/AdvisorDashboard';
import { CompanyAdminDashboard } from '../components/dashboard/CompanyAdminDashboard';
import { SuperAdminDashboard } from '../components/dashboard/SuperAdminDashboard';

export default function Dashboard() {
  const { userProfile } = useAuth();

  if (!userProfile) {
    return (
      <div style={{
        minHeight: '100vh',
        background: dpsTheme.colors.background.primary,
        paddingTop: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{ color: dpsTheme.colors.text.muted }}>Chargement...</div>
      </div>
    );
  }

  switch (userProfile.role) {
    case 'super_admin':
      return <SuperAdminDashboard />;
    case 'company_admin':
      return <CompanyAdminDashboard />;
    case 'advisor':
      return <AdvisorDashboard />;
    default:
      return <ClientDashboard />;
  }
}
